// Global
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import { classnames } from 'tailwindcss-classnames';
// Components
import Container from 'components/helpers/Container';
import PlaceholderWrapper from 'components/helpers/PlaceholderWrapper/PlaceholderWrapper';
import { Components } from '.generated/templates/Feature.Components.model';
import Heading, { propsFromFields } from 'components/helpers/Heading';
import { MissingDataSource } from 'components/helpers/EditingHelpText';
import LayoutColumnsGrid, { columnCss } from 'components/helpers/LayoutColumnsGrid';
import useExperienceEditor from 'lib/sitecore/use-experience-editor';

export type LayoutFourColumnProps = Sitecore.Override.ComponentBase &
  Components.Layout.Fields.ColumnLayout;

export type LayoutFourColumnShellProps = {
  first: JSX.Element;
  second: JSX.Element;
  third: JSX.Element;
  fourth: JSX.Element;
};

export const LayoutFourColumnShell = ({
  first,
  second,
  third,
  fourth,
}: LayoutFourColumnShellProps): JSX.Element => {
  const isEE = useExperienceEditor();
  const firstPlaceholder = first.props.rendering?.placeholders['nmdp-one-fourth-first'];
  const firstPlaceholderIsEmpty = firstPlaceholder?.length === 0;
  const secondPlaceholder = second.props.rendering?.placeholders['nmdp-one-fourth-second'];
  const secondPlaceholderIsEmpty = secondPlaceholder?.length === 0;
  const thirdPlaceholder = third.props.rendering?.placeholders['nmdp-one-fourth-third'];
  const thirdPlaceholderIsEmpty = thirdPlaceholder?.length === 0;
  const fourthPlaceholder = fourth.props.rendering?.placeholders['nmdp-one-fourth-fourth'];
  const fourthPlaceholderIsEmpty = fourthPlaceholder?.length === 0;

  return (
    <LayoutColumnsGrid columns={4}>
      {(isEE || !firstPlaceholderIsEmpty) && <div className={columnCss}>{first}</div>}
      {(isEE || !secondPlaceholderIsEmpty) && <div className={columnCss}>{second}</div>}
      {(isEE || !thirdPlaceholderIsEmpty) && <div className={columnCss}>{third}</div>}
      {(isEE || !fourthPlaceholderIsEmpty) && <div className={columnCss}>{fourth}</div>}
    </LayoutColumnsGrid>
  );
};

const LayoutFourColumn = ({ rendering, fields }: LayoutFourColumnProps): JSX.Element => {
  if (fields === null || fields === undefined) {
    return <MissingDataSource />;
  }

  const headingProps = propsFromFields(fields);

  return (
    <Container size="standard" dataComponent="authorable/layout/layout-four-column">
      <div className={fields?.description.value ? classnames('mb-8') : ''}>
        <Heading {...headingProps} descriptionClassName={classnames('text-base')} />
      </div>
      <LayoutFourColumnShell
        first={<PlaceholderWrapper name="nmdp-one-fourth-first" rendering={rendering} />}
        second={<PlaceholderWrapper name="nmdp-one-fourth-second" rendering={rendering} />}
        third={<PlaceholderWrapper name="nmdp-one-fourth-third" rendering={rendering} />}
        fourth={<PlaceholderWrapper name="nmdp-one-fourth-fourth" rendering={rendering} />}
      />
    </Container>
  );
};

export default LayoutFourColumn;
